import(/* webpackMode: "eager", webpackExports: ["message","success","error"] */ "__barrel_optimize__?names=message!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["CountUpNumber"] */ "/app/src/components/CountUpNumber/page.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/homeComponent/Certificate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/InquryForm/ContactFormTwo.tsx");
